import { UtilityBar } from "@/components/organisms/UtilityBar";

export function FinancialAccountsSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
